/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialogCreateUser.vue?vue&type=template&id=1873ff33&scoped=true"
import script from "./dialogCreateUser.vue?vue&type=script&lang=js"
export * from "./dialogCreateUser.vue?vue&type=script&lang=js"
import style0 from "./dialogCreateUser.vue?vue&type=style&index=0&id=1873ff33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873ff33",
  null
  
)

export default component.exports